import { render, staticRenderFns } from "./UpdateRealmSecurity.vue?vue&type=template&id=3d3e308e&scoped=true&"
import script from "./UpdateRealmSecurity.vue?vue&type=script&lang=ts&"
export * from "./UpdateRealmSecurity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e308e",
  null
  
)

export default component.exports